import { useSimpleReadPattern } from 'apps/sigma2-ui/src/lib/hooks/useSimpleReadPattern';
import { useCallback } from 'react';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';
import { DataSets } from 'libs/end-to-end/src/types/databases/data-sets/data-sets';

export const useListDataSetsPattern = ({
  organizationId,
  databaseId,
}: {
  organizationId: string;
  databaseId: string;
}) => {
  const listDataSetsGetUrlFn = useCallback(() => {
    return `${getApiBaseUrl()}/organizations/${organizationId}/databases/${databaseId}/data-sets`;
  }, [organizationId, databaseId]);

  return useSimpleReadPattern({
    getUrlFn: listDataSetsGetUrlFn,
    responseSchema: DataSets,
    canRead: true,
  });
};
